<template>
    <ui-dropdown placement="bottom-start" menu-class="w-full max-w-lg">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 max-h-64 overflow-y-auto">

                <!-- Empty State. -->
                <div v-if="! query" class="text-gray-500 text-sm">
                    Start typing to search for specs...
                </div>

                <div v-else class="space-y-6">
                    <!-- New Item. -->
                    <div>
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Create new spec for this estimate</div>
                        <button :class="buttonClass" class="flex items-center space-x-2" @click.stop="selectNewLocalSpec(close)">
                            <i class="fa fa-plus text-gray-400 text-sm"></i>
                            <div v-text="query"></div>
                        </button>
                    </div>

                    <!-- Local Specs. -->
                    <div v-if="filteredLocalSpecs.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Specs used within this estimate</div>
                        <div class="space-y-1">
                            <global-specs-button
                                v-for="spec in filteredLocalSpecs"
                                :key="`local-${spec.id}`"
                                :spec="spec"
                                class="hover:bg-gray-100"
                                @click.stop="selectLocalSpec(spec, close)"
                            ></global-specs-button>
                        </div>
                    </div>

                    <!-- Global Specs. -->
                    <div v-if="filteredGlobalSpecs.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">All specs available</div>
                        <div class="space-y-2">
                            <global-specs-button
                                v-for="spec in filteredGlobalSpecs"
                                :key="`global-${spec.id}`"
                                :spec="spec"
                                class="hover:bg-gray-100"
                                @click.stop="selectGlobalSpec(spec, close)"
                            ></global-specs-button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>
import { sortBy } from 'lodash'
import { estimateStore } from '@stores'

export default {
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
    },
    data () {
        return {
            query: '',
        }
    },
    computed: {
        $store () {
            return estimateStore
        },
        filteredLocalSpecs () {
            return this.$store.state.localSpecs.filter(this.matchSpec)
        },
        filteredGlobalSpecs () {
            return sortBy(
                this.$store.state.globalSpecs.filter(this.matchSpec),
                item => `${item.approved ? '0' : '1'}-${item.name}`
            )
        },
    },
    methods: {
        scope (dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        setQuery (query) {
            this.query = query
            if (! this.query) return
        },
        matchSpec (spec) {
            const query = this.query.toLowerCase()
            return spec.title.toLowerCase().includes(query) ||
                spec.description.toLowerCase().includes(query)
        },
        selectNewLocalSpec (close) {
            this.$emit('selected:new', this.query)
            this.query = ''
            close()
        },
        selectLocalSpec (spec, close) {
            this.$emit('selected:local', spec)
            this.query = ''
            close()
        },
        selectGlobalSpec (spec, close) {
            this.$emit('selected:global', spec)
            this.query = ''
            close()
        },
    },
}
</script>
